import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Esemplare } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesEsemplare, validationSchemaEsemplare } from "./EsemplareCommon"
import EsemplareForm from "./EsemplareForm"
import { useMemo } from "react"
import { useEsemplareCreate } from "../../hooks/esemplari"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function EsemplareCreate() {
  const createEsemplare = useEsemplareCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Esemplari", href: "/edizioni/esemplari" }, { label: "Creazione Esemplare" }])

  const initialValues = useMemo(() => initialValuesEsemplare(), [])
  const validationSchema = useMemo(() => validationSchemaEsemplare(true), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo esemplare</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createEsemplare.mutateAsync(values as Esemplare).then((esemplare) => {
                navigate(`/edizioni/esemplari`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <EsemplareForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/esemplari" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
